import type { CanduEvent } from '../../integrations/Candu/CanduIntegration';
import type { LogRocketEvent } from '../../integrations/LogRocket/LogRocketEvent';
import type { TrackIntegration } from './TrackIntegration';

export type TrackServiceEvent = LogRocketEvent | CanduEvent;

export class TrackService {
  protected track?: TrackIntegration;

  private preloadEvents: TrackServiceEvent[] = [];

  public get active(): boolean {
    return !!this.track && this.track.active;
  }

  get integration(): TrackIntegration | undefined {
    return this.track;
  }

  public start(track: TrackIntegration): void {
    if (this.active) {
      return;
    }

    this.track = track;

    this.track.start();

    this.preloadEvents.forEach(e => {
      this.track?.trackEvent(e);
    });

    this.preloadEvents = [];
  }

  public trackEvent(event: TrackServiceEvent): void {
    if (!this.active) {
      this.preloadEvents.push(event);

      return;
    }

    this.track?.trackEvent(event);
  }

  public trackEventWithSampling(event: TrackServiceEvent, samplingRate: number): boolean {
    const randomValue = Math.random() * 100;

    if (randomValue < samplingRate) {
      this.trackEvent(event);

      return true;
    }

    return false;
  }
}
